import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import axios from 'axios';
import React from 'react'
import { Subject } from 'rxjs';
import { FormPane } from '../../../components/FormZero/PageComponents/FormPane/FormPane';
import { IRoute } from '../../../interfaces/Logistics/Route';
import { ICustomerLocation } from '../../../interfaces/Logistics/CustomerLocation';

type CustomerLocationModalProps = {
    routes: [],
    openRoute: IRoute,
    showDialog: boolean,
    setShowDialog: (showDialog: boolean) => void,
    loadRoutes: () => Promise<void>
}

export default function AddCustomerLocationModalControl(props: CustomerLocationModalProps) {
    const { routes, openRoute, loadRoutes, showDialog, setShowDialog } = props;
    const [formStructure, setFormStructure] = React.useState<any>([]);

    React.useEffect(() => {
        if (routes !== undefined) {
            setFormStructure([
                {
                    key: "route", size: { default: 12 }, type: "select", label: "Route",
                    options: routes.map((route: { [x: string]: any; id: any; }) => {
                        return { label: route.name, value: route.id }
                    })
                },
                { key: "customerName", size: { default: 12 }, type: "text", label: "Customer Name" },
                { key: "city", size: { default: 12 }, type: "text", label: "City" },
                { key: "state", size: { default: 12 }, type: "text", label: "State" },
            ])
        }
    }, [routes]);


    const createRoute = async function () {
        try {
            // const result
            console.log("UPDATED", formValues);
            let location: ICustomerLocation = {
                id: 0,
                routeId: formValues.route,
                customerName: formValues.customerName,
                city: formValues.city,
                state: formValues.state
            }
            await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/CustomerLocations`, location).then(async (resp) => {
                if (resp.status === 201) {
                    await loadRoutes();
                    setShowDialog(false);
                    formSubject.next({});
                } else {
                    console.log(resp);
                }
            });

        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };

    const [formValues, setFormValue] = React.useState<any>({ route: openRoute != undefined ? openRoute.id : 0 });

    const formSubject = new Subject();
    formSubject.subscribe((v: any) => {
        let data = { ...formValues, ...v };
        setFormValue(data);
    });

    React.useEffect(() => {
        console.log("Open Route");
        console.log(openRoute);
        if (openRoute !== undefined && openRoute.id > 0) {
            let v = { ...formValues, route: openRoute.id }
            console.log(v);
            setFormValue(v)
        }

        if (openRoute !== undefined && openRoute.id == 0) {
            // should remove the set to any route initially.
            let v = { ...formValues };
            console.log(v);
            setFormValue(v);
        }

    }, [openRoute])

    return (
        <Dialog
            open={showDialog}
            onClose={() => setShowDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                Add Customer
            </DialogTitle>
            <DialogContent style={{ width: '300px' }}>
                {/*<pre>{JSON.stringify(formValues, undefined, 4)}</pre>*/}
                <FormPane formStructure={formStructure} formSubject={formSubject}
                    initialFormData={formValues} />
            </DialogContent>
            <DialogActions>
                <div style={{ display: 'flex', width: '100%', gap: '0.5rem' }}>
                    <div style={{ flexGrow: 1 }}>
                        <Button variant='contained' onClick={() => setShowDialog(false)} autoFocus fullWidth ><Typography variant="h6" color="#FFF" textAlign="left" fontWeight={600}>Close</Typography></Button>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        <Button variant='contained' color='secondary' onClick={() => createRoute()} autoFocus fullWidth><Typography variant="h6" color="#FFF" textAlign="left" fontWeight={600}>Add</Typography></Button>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    )
}
